import { colors } from '@mobi/component-library/Theme/Common'
import type { PromoTypeClass } from './types'

export const promoTypeColorThemes: Record<
  `&.${PromoTypeClass}`,
  { '--light-color': string; '--dark-color': string }
> = {
  '&.PromoType-Bonus': {
    '--light-color': colors.celery[50],
    '--dark-color': colors.celery[600],
  },

  '&.PromoType-Special': {
    '--light-color': colors.lavender[50],
    '--dark-color': colors.studio[600],
  },

  '&.PromoType-SuperPick': {
    '--light-color': colors.orange[50],
    '--dark-color': colors.black,
  },
}
